<template>
  <b-card title="عکس">
    <b-card-text>
      <span>در این قسمت می توانید به محتوای خود عکس اضافه کنید </span>
    </b-card-text>


    <b-row>
      <b-col cols="12">
        <b-form-group
            label="آپلود عکس"

        >
          <b-form-file
              v-model="file"
              placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
              drop-placeholder="Drop file here..."
              accept=".jpg,.svg, .png"
              @change="handleImageUpload($event)"
          />
        </b-form-group>
        <div class="mt-2 image-preview" >
          <b-img :src="imagePreView" v-show="showImagePreView" fluid  />
        </div>
      </b-col>

    </b-row>







  </b-card>
</template>

<script>
import {BFormTextarea, BCardText,BRow,BCol,BImg, BFormFile,BCard, BFormGroup, BFormInput, BButton} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import UploadFile from '@/modules/components/upload/uploadFile'
import uploadService from "@/modules/services/uploadService";


export default {
  name: "imageGalleryForm",
  components: {
    BCard,
    BButton,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BImg,
    BCardText,
    UploadFile,
    BFormFile,
    BRow,
    BCol

  },
  data() {
    return {
      imageFile:undefined,
      imagePreView:undefined,
      showImagePreView:undefined,
      selectedFile:'',
      imageUrl:'',
      data: {
        name: '',
        imageAddress: '',
        link:''
      },
    }
  },
  methods: {
    async SaveContent(event) {

      this.data.imageAddress = await uploadService.upload(this.file)
      this.$emit('imageFormSubmit', this.data)
    },
    handleImageUpload(event) {
      this.imageFile = event.target.files[0]

      console.log('handleCoverImageUpload')
      let reader = new FileReader();

      reader.addEventListener("load", function () {


        this.showImagePreView = true;
        this.imagePreView = reader.result;
        this.$emit('imageChanged', this.imageFile);

      }.bind(this), false);

      if (this.imageFile) {
        /*
          Ensure the file is an image file.
        */

        if (/\.(jpe?g|png)$/i.test(this.imageFile.name)) {

          /*
            Fire the readAsDataURL method which will read the file in and
            upon completion fire a 'load' event which we will listen to and
            display the image in the preview.
          */

          reader.readAsDataURL(this.imageFile);
        }
      }

    },
  }
  ,
  directives: {
    Ripple,
  },

}
</script>

<style scoped>
.ck-editor__editable  {
  height: 400px !important;
}

.image-preview {
  max-width: 300px;
  max-height: 150px;
  alignment: center;
  margin-bottom: 3rem;
}
</style>
